<template>
  <v-container>
    <v-btn color="#4d48f9" @click="timePeriodAdd()" style="text-transform: none !important;color:white;">YENİ ZAMAN ARALIĞI EKLE</v-btn>
    <br />
    <br />

    <v-card>
      <v-card-title>
        Sipariş Verme Süreleri
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Ara"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="allTimePeriodList"
        :footer-props="{
    'items-per-page-options': [25,50,75,100]
  }"
        :items-per-page="10"
        :search="search"
      >
        <template v-slot:item.active="{ item }">
          <v-checkbox v-model="item.active" @change="timePeriodStatusChange(item)" color="#4d48f9" ></v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="timePeriodEdit(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TimePeriods",
    data: () => ({
    search: "",
    headers: [
      { text: "Sipariş Verme Süresi (dk.)", value: "timePeriod" },
      { text: "Aktif/Pasif", value: "active" },
      { text: "Detay", value: "actions", sortable: false }
    ]
  }),
  computed: mapGetters(["allTimePeriodList"]),
    created() {
    this.getTimePeriods();
  },
  methods: {
    ...mapActions(["getTimePeriods","updateTimePeriod"]),
    //TimePeriodStatusChange
    timePeriodStatusChange(timePeriod) {
      // console.log("timePeriod", timePeriod);
      this.updateTimePeriod(timePeriod).then(response=>{
        //  console.log("response",response);
         if(response.processStatus=="Success") {
           alert("Güncelleme işlemi başarılıdır");
         }
         else {
           alert("Bir hata oluştu");
         }
       }).catch(err=>{
           alert(err);
       })

    },
    //TimePeriodAdd
    timePeriodAdd() {
      this.$router.push("timePeriod");
    },
    //TimePeriodDetail
    timePeriodEdit(item) {
      this.$router.push(`/dashboard/productCategories/timePeriod/${item.id}`);
    }
  }
};
</script>

<style>
</style>